﻿import { useMutation } from 'react-query';
import ImageProcessingApi from '../../api/ImageProcessingApi';
import { RoomTag } from '../view/ImageProcessingRoomTagging';

export function useSaveRoomTag(
    orderId: number,
    imageId: number,
    onError: (error: unknown) => void
) {
    let saveRoomTagMutation = useMutation(({ roomTags }: { roomTags: RoomTag[] }) =>
        ImageProcessingApi.saveRoomTags(orderId, imageId, roomTags), {
        onError: (error: unknown, variables: any) => {
            onError(error, variables.roomTags);
        }
      }
    );

    return async function handleSaveRoomTag(roomTags: RoomTag[]): Promise<void> {
        await saveRoomTagMutation.mutate({ roomTags });
    };
}

